/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */
import $ from 'jquery';

document.addEventListener("DOMContentLoaded", function() {
  const el = document.querySelector("[data-charcount]");
  if (el) {
    el.setAttribute("data-charcount", "482");
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // duplicate header social to the other responsive headers without overriding their templates

  const $headerSocials = $('.header .header-desktop').find('.header__socials');
  $headerSocials
    .clone(true, true)
    .prependTo('.header-mobile .header-section-bottom .container-header-wrapper__right');
  $headerSocials
    .clone(true, true)
    .prependTo('.header-tablet .header-section-bottom .container-header-wrapper__right');

  // INT-JUNE - use customize card to supply custom icon to the pricing features special

  const $inventoryPage = $('.page-template-inventory, .home-featured-inventory');

  function replaceSpecialFeatureIcon() {
    $('.vehicle').each(function () {
      const $vehicle = $(this);
      $vehicle
      .find('.feature_special.special')
      .each(function () {
          const $customIconOverlay = $vehicle.find('.custom-icon-overlay').clone(true, true);
          $(this).find('.special-overlay').replaceWith($customIconOverlay);
        });
    });
  }

  if ($inventoryPage.length != 0) {
    replaceSpecialFeatureIcon();
    $(document).on('post_render_inventory_search_results', function () {
      replaceSpecialFeatureIcon();
    });
  }


  const $vdpPage = $('.vdp-page');

  if ($vdpPage.length != 0) {
    // remove financing from calculator 
    const $leaseButton = $('#show-lease-info');
    const $financeButton = $('#show-finance-info');
    $financeButton.parents('.nav-item').remove();
    if ($leaseButton.length != 0) {
      $leaseButton.trigger('click');
    }
    $vdpPage.find('.calc-form__cta').find('.button .button__text').text('Get Your Real Rate');
    $vdpPage.find('.calc-form').find('.calc-form__subtitle').text('For illustration only — actual rate subject to credit approval');

  }


});

$('.js-trim-text').each(function () {
  const html = $(this).data('text');
  const charCount = parseInt($(this).data('charcount'), 10);

  if (!html || !charCount) {
    return;
  }

  const temp = document.createElement('div');
  temp.innerHTML = html;

  let count = 0;
  let truncated = false;

  function trimNode(node) {
    if (truncated) {
      node.remove();
      return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;

      if (count + text.length > charCount) {
        const remaining = charCount - count;

        node.textContent = text.substring(0, remaining).trimEnd() + '...';
        count = charCount;
        truncated = true;
      } else {
        count += text.length;
      }

      return;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      Array.from(node.childNodes).forEach(trimNode);
    }
  }

  Array.from(temp.childNodes).forEach(trimNode);

  $(this).html(temp.innerHTML);
});
